import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimWhiteSpace]'
})
export class TrimWhiteSpaceDirective {
  @Output() ngModelChange = new EventEmitter();

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('focusout') onFocusOut() {
    let inputValue = (this.el.nativeElement as HTMLInputElement).value;
    if (inputValue && typeof inputValue === 'string') {
      inputValue = inputValue.trim();
      inputValue = inputValue.replace(/\s+/g, ' ');
      this.ngModelChange.emit(inputValue);
      this.control.control?.setValue(inputValue);
    }
  }
}
